export function resolveWithCredentials(useAuth: boolean, withCredentials?: boolean): boolean {
  if (!useAuth) {
    return false;
  }

  return withCredentials ?? true;
}

export function buildCookieHeader(cookies: Array<{ name: string; value: string }>): string {
  return cookies.map(({ name, value }) => `${name}=${encodeURIComponent(value)}`).join("; ");
}
